import { render, staticRenderFns } from "./BreadCrumbItem.vue?vue&type=template&id=fe02645e&scoped=true&"
import script from "./BreadCrumbItem.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumbItem.vue?vue&type=script&lang=ts&"
import style0 from "./BreadCrumbItem.vue?vue&type=style&index=0&id=fe02645e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe02645e",
  null
  
)

export default component.exports